import React, { ReactElement } from 'react'
import { MemberDetailsPage } from 'src/ui/page/common/member/details/MemberDetailsPage'

export const ServicerDetailsPage = (): ReactElement => {
  return <MemberDetailsPage isServicer />
}
